import script from "./ModifyScheduleElementPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModifyScheduleElementPage.vue?vue&type=script&lang=ts&setup=true"

import "./ModifyScheduleElementPage.vue?vue&type=style&index=0&id=c430a3e0&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c430a3e0"]])

export default __exports__